import Sentry from '@/3rd-parties/sentry'
import countingApi from '@/api/counting'

const audienceSendCountingUniqueAction = async (_, payload) => {
  try {
    const countingPayload = {
      counts: [
        payload,
      ],
    }
    await countingApi.sendCountingUnique(countingPayload)
  } catch (error) {
    Sentry.captureException(error)
    // do nothing
  }
}

export default {
  audienceSendCountingUniqueAction,
}
